import * as z from "zod";

declare global { const auth: Auth; }

export const authSchema = z.object({
  is_logged_in: z.boolean(),
  login_url: z.url(),
  logout_url: z.url(),
});
export type Auth = z.infer<typeof authSchema>;
